export default __webpack_public_path__ + "static/media/simona-cotin.6c591685.png";